export default __webpack_public_path__ + "static/media/logo.465a1dcd.png";